"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUseDOM = canUseDOM;
/**
 * Verifies if an application can use DOM.
 */
function canUseDOM() {
    return (
    // eslint-disable-next-line no-restricted-globals
    typeof window !== 'undefined' &&
        !!(
        // eslint-disable-next-line no-restricted-globals, @typescript-eslint/no-deprecated
        (window.document && window.document.createElement)));
}
//# sourceMappingURL=canUseDOM.js.map